export const BUILD_INFO = { sha: 'a7bd61f' };
